"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButton = exports.classes = void 0;
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const styles_1 = require("@mui/material/styles");
const PREFIX = "RollerSelector";
exports.classes = {
    root: `${PREFIX}-root`,
    selected: `${PREFIX}-selected`,
    icon: `${PREFIX}-icon`
};
exports.StyledButton = (0, styles_1.styled)(ButtonBase_1.default)(({ theme }) => ({
    fontFamily: "Effra Regular",
    background: "transparent",
    color: theme.colours.inter,
    border: "none",
    padding: "8px 15px",
    fontSize: "1.5rem",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    lineHeight: "1.5em",
    textAlign: "left",
    "&:hover": {
        background: `${theme.colours.black}0d`,
        color: theme.colours.focus
    },
    [`&.${exports.classes.selected}`]: {
        fontFamily: "Effra Medium",
        fontWeight: "bold",
        [`.${exports.classes.icon}`]: {
            opacity: 1
        }
    },
    [`.${exports.classes.icon}`]: {
        marginLeft: "15px",
        display: "inline-block",
        width: "24px",
        height: "24px",
        opacity: 0,
        transition: "opacity ease-out 0.28s"
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3JvbGxlci1zZWxlY3Rvci9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsMEVBQWtEO0FBQ2xELGlEQUE4QztBQUU5QyxNQUFNLE1BQU0sR0FBRyxnQkFBZ0IsQ0FBQztBQUVuQixRQUFBLE9BQU8sR0FBRztJQUNyQixJQUFJLEVBQUUsR0FBRyxNQUFNLE9BQU87SUFDdEIsUUFBUSxFQUFFLEdBQUcsTUFBTSxXQUFXO0lBQzlCLElBQUksRUFBRSxHQUFHLE1BQU0sT0FBTztDQUN2QixDQUFDO0FBRVcsUUFBQSxZQUFZLEdBQUcsSUFBQSxlQUFNLEVBQUMsb0JBQVUsQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUM3RCxVQUFVLEVBQUUsZUFBZTtJQUMzQixVQUFVLEVBQUUsYUFBYTtJQUN6QixLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO0lBQzFCLE1BQU0sRUFBRSxNQUFNO0lBQ2QsT0FBTyxFQUFFLFVBQVU7SUFDbkIsUUFBUSxFQUFFLFFBQVE7SUFDbEIsT0FBTyxFQUFFLE1BQU07SUFDZixjQUFjLEVBQUUsWUFBWTtJQUM1QixVQUFVLEVBQUUsUUFBUTtJQUNwQixNQUFNLEVBQUUsU0FBUztJQUNqQixVQUFVLEVBQUUsT0FBTztJQUNuQixTQUFTLEVBQUUsTUFBTTtJQUNqQixTQUFTLEVBQUU7UUFDVCxVQUFVLEVBQUUsR0FBRyxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUssSUFBSTtRQUN0QyxLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO0tBQzNCO0lBQ0QsQ0FBQyxLQUFLLGVBQU8sQ0FBQyxRQUFRLEVBQUUsQ0FBQyxFQUFFO1FBQ3pCLFVBQVUsRUFBRSxjQUFjO1FBQzFCLFVBQVUsRUFBRSxNQUFNO1FBQ2xCLENBQUMsSUFBSSxlQUFPLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtZQUNwQixPQUFPLEVBQUUsQ0FBQztTQUNYO0tBQ0Y7SUFDRCxDQUFDLElBQUksZUFBTyxDQUFDLElBQUksRUFBRSxDQUFDLEVBQUU7UUFDcEIsVUFBVSxFQUFFLE1BQU07UUFDbEIsT0FBTyxFQUFFLGNBQWM7UUFDdkIsS0FBSyxFQUFFLE1BQU07UUFDYixNQUFNLEVBQUUsTUFBTTtRQUNkLE9BQU8sRUFBRSxDQUFDO1FBQ1YsVUFBVSxFQUFFLHdCQUF3QjtLQUNyQztDQUNGLENBQUMsQ0FBQyxDQUFDIn0=